import * as moment from 'moment';

export function isDate(value: any): boolean {
  if (value instanceof Date) {
    return true;
  }

  if (moment.isMoment(value)) {
    return true;
  }

  return false;
}
